export default "__VITE_ASSET__BM5os_Ak__"